import {AppFunction} from "../misc/types";
import {DeliveryView} from "../views/delivery";
import {PickupView} from "../views/pickup";
import {setDeliveries} from "../misc/delivery";

export class DeliveryFunction extends AppFunction {

    readonly v : DeliveryView;

    constructor(override_ids?: string[]) {
        super();
        if (override_ids) {
            setDeliveries(override_ids);
        }
        this.v = new DeliveryView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/deliveries`;
    }

}

export class PickupsFunction extends AppFunction {

    readonly v : PickupView;

    constructor() {
        super();
        this.v = new PickupView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/pickups`;
    }

}
